



















export default {
  name: 'Textfield'

  props: 
    id: ''
    label: ''
    value: ''
    tabindex: ''
    validate:
      default: ''
    isInvalid: false
    errorMsg: null

  mounted: () ->
    componentHandler.upgradeElements @$el

  methods: 
    onInput: (event) ->
      @$emit 'input', event.target.value
      componentHandler.upgradeElements @$el

      @$validator.validateAll()
      .then () =>
        @$emit 'valid'
      .catch () =>
        @$emit 'errors', @$validator.getErrors().errors     

  # computed:
  #   errorMsg: () ->
  #     @errors.all().join('<br>')
       
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/Textfield.vue